export enum EfasConcepts {
  'clean',
  'qualified_opinion',
  'adverse_opinion',
  'disclaimer_of_opinion',
  'pending',
}
